import styled, { css } from 'styled-components';

export const SectionWrapper = styled.div(
  ({ theme }) => css`
    grid-area: prices;
    align-self: start;
    position: sticky;
    top: ${theme.sz.s5};

    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};
    align-items: center;
    padding: ${theme.sz.s12};
    border-radius: ${theme.bo.mediumLarger};
    background-color: ${theme.co.primary98};
    box-shadow: 0 ${theme.sz.s1} 0 ${theme.co.neutral80};

    @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
      padding: ${theme.sz.s12} ${theme.sz.s6};
    }

    @media (max-width: ${theme.sz.lg}) {
      position: unset;
      background-color: unset;
      box-shadow: unset;
      padding: ${theme.sz.s0};
    }

    @media (max-height: ${theme.sz.ms}) {
      position: unset;
    }
  `,
);

export const SectionTitle = styled.h2(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    ${theme.typography.heading.desktop.s};
  `,
);

export const Actions = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};

    @media (max-width: ${theme.sz.lg}) {
      display: none;
    }
  `,
);
